import { render, staticRenderFns } from "./callHistory.vue?vue&type=template&id=667d9822&scoped=true"
import script from "./callHistory.vue?vue&type=script&lang=js"
export * from "./callHistory.vue?vue&type=script&lang=js"
import style0 from "./callHistory.vue?vue&type=style&index=0&id=667d9822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d9822",
  null
  
)

export default component.exports